import { LegalAndTermsFormErrorJSON } from '../models/legal-terms';

export const formLegalAndTermsErrors: LegalAndTermsFormErrorJSON = {
    privacyUrl: [
        {
            code: 'pattern',
            message: 'Invalid url',
        },
    ],
    termsUrl: [
        {
            code: 'pattern',
            message: 'Invalid url',
        },
    ],
    faqURL: [
        {
            code: 'pattern',
            message: 'Invalid url',
        },
    ],
};
